import { Input } from "antd";
import cls from "classnames";
import { useEffect, useRef } from "react";
import useState from "react-usestateref";
import styles from "./InterviewBot.module.scss";
import MakeACall from "./MakeACall";
import { NO_WHEEL } from "../constants";

const { TextArea } = Input;

type InterviewBotProps = {
  noWheelClassName: string;
  textAreaValue: {
    msg: string;
    loading: boolean;
  };
  onTextAreaFocus: () => void;
};

function InterviewBot(props: InterviewBotProps) {
  const { textAreaValue } = props;
  const { msg, loading } = textAreaValue;

  const [AIDesc, setAIDesc] = useState(msg);
  const [focused, setFocused] = useState(false);

  const textareaRef = useRef(null);

  const handleFocus = () => {
    props.onTextAreaFocus();
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  const handleChangeTextarea: React.ChangeEventHandler<HTMLTextAreaElement> = e => {
    setAIDesc(e.target.value);
  };

  const handleUpdateAgentDescription = () => {
    console.error("called");
  };

  useEffect(() => {
    if (msg) {
      setAIDesc(msg);
    }
  }, [msg]);

  const whatTodoClassName = cls(styles.whatTodo, NO_WHEEL, focused && styles.focused, focused && "nodrag");

  return (
    <div className={styles.inner}>
      <TextArea
        ref={textareaRef}
        rows={8}
        onClick={handleFocus}
        onBlur={handleBlur}
        onChange={handleChangeTextarea}
        className={whatTodoClassName}
        value={AIDesc || ""}
        onPressEnter={handleUpdateAgentDescription}
        placeholder="What do you want the AI to do"
        autoSize={true}
      />
      <MakeACall edgeDataLoading={loading} AIDesc={AIDesc} msg={msg} onFocus={() => props.onTextAreaFocus()} />
    </div>
  );
}

export { InterviewBot };
